import React, { useEffect, useState } from "react";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { get, post } from "../../services/api";
import Select from "react-select";
import { toast } from "react-toastify";
import Elements from "../../components/elements/Elements";
import { useNavigate, useSearchParams } from "react-router-dom";
import CheckDependencyModal from "../../components/CheckDependencyModal";
import NotificationEventTypes from "../../constants/notificationEventsEnum";

function StudentForm() {
  const token = localStorage.getItem("token");
  const organizationId = localStorage.getItem("organizationId");
  const centerId = localStorage.getItem("centerId");

  const navigate = useNavigate();

  const [searchParams] = useSearchParams();

  const voucherNoFromUrl = searchParams.get("voucherNo");
  const studentIdFromUrl = searchParams.get("studentId");

  const [showDependencyModal, setShowDependencyModal] = useState(false);
  const [elementsData, setElementsData] = useState([]);
  const [loadingElements, setLoadingElements] = useState(true);
  const getDefaultStudentFormValues = () => ({
    id: 0,
    createdBy: localStorage.getItem("userId"),
    studentImage: "",
    imagePath: "",
    base64String: "",
    centerSessionId: "",
    centerId: "",
    centerClassId: "",
    code: "",
    rollNo: 0,
    voucherNo: voucherNoFromUrl,
    registrationNo: "",
    guardianIdentityNo: "",
    firstName: "",
    lastName: "",
    grandParentsName: "",
    guardianName: "",
    gender: "",
    dateOfBirth: "",
    admissionDate: null,
    placeOfBirth: "",
    nationality: "",
    religion: "",
    language: "",
    isDisabled: false,
    disabledDescription: "",
    isMedical: false,
    medicalDescription: "",
    isOnMedication: false,
    medicationDescription: "",
    isDivorced: false,
    custodianName: "",
    classSectionId: "",
    careTakerId: 0,
    organizationId: localStorage.getItem("organizationId"),

    isITDeviceAllocated: false,
    itRemarks: "",
    itDeviceAllocatedDate: "",
    isUniformAllocated: false,
    uniformRemarks: "",
    uniformAllocatedDate: "",
    isStationeryAllocated: false,
    stationeryRemarks: "",
    stationeryAllocatedDate: "",
    isCardPriniting: false,
    cardPrinitingRemarks: "",
    cardPrinitingAllocatedDate: "",
    accountString: "",
    elements: [
      {
        name: "",
        description: "",
        createdBy: localStorage.getItem("userId"),
        elementDetail: {
          value: "",
          description: "",
          effectiveDate: null,
          endDate: null,
          createdBy: localStorage.getItem("userId"),
          fileName: "",
          filePath: "",
          base64String: "",
        },
      },
    ],
  });

  const {
    register,
    formState: { errors, isSubmitting },
    control,
    handleSubmit,
    watch,
    setValue,
    setError,
    clearErrors,
    trigger,
    reset,
    getValues,
  } = useForm({
    defaultValues: getDefaultStudentFormValues(),
  });
  useEffect(() => {
    const fetchElements = async () => {
      try {
        const elementsResponse = await get("Dropdown/GetElements", {
          headers: { Authorization: `Bearer ${token}` },
        });
        setElementsData(elementsResponse);
        setLoadingElements(false); // Add a state to track loading
      } catch (error) {
        console.error("Error fetching elements:", error);
        setLoadingElements(false);
      }
    };
    fetchElements();
  }, []);
  if (voucherNoFromUrl) {
    setValue("voucherNo", voucherNoFromUrl);
  }
  const { fields, append, remove } = useFieldArray({
    control,
    name: "elements",
  });
  useEffect(() => {
    fetchFirstRegistrationData();
  }, [voucherNoFromUrl]);

  const {
    fields: elementsFormFields,
    append: appendElementsFormFields,
    remove: removeElementsFormFields,
  } = useFieldArray({
    control,
    name: "elements",
  });
  const handleAttachmentFileChange = (event, index) => {
    const file = event.target.files[0]; // Get only the first selected file

    if (file) {
      // Update the file count to 1 since we're only allowing one file
      setFileCounts((prevCounts) => ({
        ...prevCounts,
        [index]: 1,
      }));

      // Set the file name
      setValue(`elements[${index}].elementDetail.fileName`, file.name, {
        shouldValidate: true,
      });

      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result.split(",")[1];

        // Set base64 string for the file
        setValue(
          `elements[${index}].elementDetail.base64String`,
          base64String,
          { shouldValidate: true }
        );

        // Create a URL for the uploaded file to display as a preview
        const fileUrl = URL.createObjectURL(file);
        setFileUrls((prevUrls) => ({
          ...prevUrls,
          [index]: fileUrl, // Update the fileUrls state with the new URL
        }));
      };

      reader.readAsDataURL(file); // Read the file as a Data URL
    } else {
      // Reset the file count to 0 if no file is selected
      setFileCounts((prevCounts) => ({
        ...prevCounts,
        [index]: 0,
      }));

      // Clear the file fields
      setValue(`elements[${index}].elementDetail.fileName`, "", {
        shouldValidate: true,
      });
      setValue(`elements[${index}].elementDetail.base64String`, "", {
        shouldValidate: true,
      });
      setValue(`elements[${index}].elementDetail.filePath`, "", {
        shouldValidate: true,
      });

      // Clear the file URL
      setFileUrls((prevUrls) => ({
        ...prevUrls,
        [index]: "", // Reset the file URL
      }));
    }
  };
  const fetchFirstRegistrationData = async () => {
    const voucherNo = getValues("voucherNo");

    if (!voucherNo) {
      setError("voucherNo", {
        type: "custom",
        message: "This field is required.",
      });
      return;
    }

    try {
      const response = await get(
        `Registration/GetRegistrationByVoucherNo?voucherNo=${voucherNo}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const { result, registration } = response;

      if (!result && !registration) {
        toast.error("No data found for this Voucher Number.");
        reset({
          voucherNo: getValues("voucherNo"),
          registrationNo: "",
          firstName: "",
          lastName: "",
          dateOfBirth: "",
          gender: "",
          nationality: "",
          religion: "",
          guardianName: "",
          relation: "",
          occupation: "",
          guardianIdentityNo: "",
          mobileNo: "",
          email: "",
          countryId: "",
          stateId: 0,
          cityId: 0,
          stateName: "",
          cityName: "",
          centerId: "",
          centerClassId: "",
          sourceOfInformation: "",
          grandParentsName: "",
          code: "",
          id: 0,
        });
        return;
      }

      if (result) {
        toast.info("Admission challan already generated.");
        reset({
          voucherNo: getValues("voucherNo"),
          registrationNo: "",
          firstName: "",
          lastName: "",
          dateOfBirth: "",
          gender: "",
          nationality: "",
          religion: "",
          guardianName: "",
          relation: "",
          occupation: "",
          guardianIdentityNo: "",
          mobileNo: "",
          email: "",
          countryId: "",
          stateId: 0,
          cityId: 0,
          stateName: "",
          cityName: "",
          centerId: "",
          centerClassId: "",
          sourceOfInformation: "",
          grandParentsName: "",
          code: "",
          id: 0,
        });
        return;
      }

      setSelectedCenterId(registration?.centerId);
      setSelectedClassId(registration?.centerClassId);

      const countryId = registration?.countryId;
      const stateId = registration?.stateId;
      const cityId = registration?.cityId;
      const centerId = registration?.centerId;
      const centerClassId = registration?.centerClassId;
      const centerSessionId = registration?.centerSessionId;

      let selectedCountry = null;
      let selectedState = null;
      let selectedCity = null;
      let selectedCenter = null;
      let selectedClass = null;
      let selectedSession = null;

      const countriesResponse = await get("Dropdown/GetCountries", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setCountries(countriesResponse);
      selectedCountry = countriesResponse.find(
        (country) => country.id === countryId
      );

      if (countryId) {
        const statesResponse = await get(
          `Dropdown/GetStates?countryId=${countryId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setStates(statesResponse);

        // if (stateId) {
        //   selectedState = statesResponse.find((state) => state.id === stateId);
        //   const citiesResponse = await get(
        //     `Dropdown/GetCities?stateId=${stateId}`,
        //     {
        //       headers: {
        //         Authorization: `Bearer ${token}`,
        //       },
        //     }
        //   );
        //   setCities(citiesResponse);

        //   if (cityId) {
        //     selectedCity = citiesResponse.find((city) => city.id === cityId);
        //     const centersResponse = await get(
        //       `Center/GetCenterByCityId?cityId=${cityId}`,
        //       {
        //         headers: {
        //           Authorization: `Bearer ${token}`,
        //         },
        //       }
        //     );
        //     setCentersData(centersResponse?.center);

        if (centerId) {
          // selectedCenter = centersResponse?.center.find(
          //   (center) => center.id === centerId
          // );
          const classesResponse = await get(
            `CenterClass/GetClassCenterByCenterId?id=${centerId}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          setClassesData(classesResponse);

          if (centerClassId) {
            const sessionsResponse = await get(
              `Session/GetSessionByCenterId?centerId=${centerId}`,
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            );

            const sessions = sessionsResponse?.session || [];
            setSessionsData(sessions);

            if (centerSessionId) {
              selectedSession = sessionsResponse?.session.find(
                (session) => session.id === centerSessionId
              );
            }

            selectedClass = classesResponse.find(
              (classItem) => classItem.id === centerClassId
            );
            const sectionsResponse = await get(
              `ClassSection/GetAllSectionByCenterClassIdAndCenterId?centerClassId=${centerClassId}&centerId=${centerId}`,
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            );
            setSectionsData(sectionsResponse);
          }
        }
        //   }
        // }
      }

      if (registration.fileName && registration.fileName.trim() !== "") {
        const imageUrl =
          process.env.REACT_APP_LIVE_DOMAIN_URL +
          "ExternalImages" +
          registration.filePath;

        setPreviewUrl(imageUrl);
        setStudentFileName(registration.fileName);
      } else {
        setPreviewUrl("");
        setStudentFileName("");
      }

      reset({
        studentFirstRegistrationId: registration?.id,
        firstName: registration?.firstName,
        lastName: registration?.lastName,
        gender: registration?.gender === 0 ? "0" : "1",
        nationality: registration?.nationality,
        guardianIdentityNo: registration?.guardianIdentityNo,
        countryId: { id: selectedCountry?.id, label: selectedCountry?.name },
        // stateId: { id: selectedState?.id, label: selectedState?.name },
        // cityId: { id: selectedCity?.id, label: selectedCity?.name },
        stateId: 0,
        cityId: 0,
        stateName: registration.stateName,
        cityName: registration.cityName,
        centerId: registration?.centerId,
        centerClassId: { id: selectedClass?.id, label: selectedClass?.name },
        centerSessionId: {
          id: selectedSession?.id,
          label: selectedSession?.name,
        },
        registrationNo: registration?.registrationNo || "",
        studentImage: registration?.fileName ?? "",
        imagePath: registration?.filePath ?? "",
        dateOfBirth: registration?.dateOfBirth.split("T")[0],
        base64String: "",
        code: "",
        createdBy: localStorage.getItem("userId"),
        organizationId: localStorage.getItem("organizationId"),

        itRemarks: registration?.itRemarks || "",
        itDeviceAllocatedDate:
          registration?.itDeviceAllocatedDate?.split("T")[0],
        isUniformAllocated: registration?.isUniformAllocated,
        uniformRemarks: registration?.uniformRemarks || "",
        uniformAllocatedDate: registration?.uniformAllocatedDate?.split("T")[0],
        isStationeryAllocated: registration?.isStationeryAllocated,
        stationeryRemarks: registration?.stationeryRemarks || "",
        stationeryAllocatedDate:
          registration?.stationeryAllocatedDate?.split("T")[0],
        isCardPriniting: registration?.isCardPriniting,
        cardPrinitingRemarks: registration?.cardPrinitingRemarks || "",
        cardPrinitingAllocatedDate:
          registration?.cardPrinitingAllocatedDate?.split("T")[0],
      });
    } catch (error) {
      console.error("Error fetching student data: ", error);
    }
  };

  const [fetchedCenterId, setFetchedCenterId] = useState(0);
  const [fetchedClassId, setFetchedClassId] = useState(0);
  const [regNo, setRegNo] = useState("");

  const [studentFileName, setStudentFileName] = useState("");
  const [previewUrl, setPreviewUrl] = useState("");

  const [fileCounts, setFileCounts] = useState({});
  const [fileUrls, setFileUrls] = useState({});

  const [languagesData, setLanguagesData] = useState([]);
  const [sessionsData, setSessionsData] = useState([]);
  const [centersData, setCentersData] = useState([]);
  const [classesData, setClassesData] = useState([]);
  const [sectionsData, setSectionsData] = useState([]);
  const [selectedCenterId, setSelectedCenterId] = useState(null);
  const [selectedClassId, setSelectedClassId] = useState(null);

  const [nanniesData, setNanniesData] = useState([]);

  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const selectedCountry = watch("countryId");
  const selectedState = watch("stateId");
  const selectedCity = watch("cityId");

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await get("Dropdown/GetCountries", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setCountries(response);
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchCountries();
  }, [token]);

  useEffect(() => {
    if (selectedCountry && selectedCountry.value) {
      const fetchStates = async () => {
        try {
          const response = await get(
            `Dropdown/GetStates?countryId=${selectedCountry.value}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          setStates(response);

          setCities([]);
          setValue("stateId", null);
          setValue("cityId", null);
        } catch (error) {
          console.error("Error fetching states:", error);
        }
      };

      fetchStates();
    }
  }, [selectedCountry, setValue, token]);

  useEffect(() => {
    if (selectedState && selectedState.value) {
      const fetchCities = async () => {
        try {
          const response = await get(
            `Dropdown/GetCities?stateId=${selectedState.value}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          setCities(response);

          setValue("cityId", null);
        } catch (error) {
          console.error("Error fetching cities:", error);
        }
      };

      fetchCities();
    }
  }, [selectedState, setValue, token]);

  // const [countries, setCountries] = useState([]);
  // const [states, setStates] = useState([]);
  // const [cities, setCities] = useState([]);

  // const selectedCountry = watch("countryId");
  // const selectedState = watch("stateId");
  // const selectedCity = watch("cityId");
  // const selectedCenter = watch("centerId");

  // useEffect(() => {
  //   const fetchCountries = async () => {
  //     try {
  //       const response = await get("Dropdown/GetCountries", {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       });
  //       setCountries(response);
  //     } catch (error) {
  //       console.error("Error fetching countries:", error);
  //     }
  //   };

  //   fetchCountries();
  // }, [token]);

  useEffect(() => {
    const getUsersByCenterIdAndRoleId = async () => {
      try {
        const response = await get(
          `UserAuthentication/GetUsersByCenterIdAndRoleId?centerId=${centerId}&roleId=${4}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setNanniesData(response);
      } catch (error) {
        console.error("Error fetching caretakers:", error);
      }
    };

    getUsersByCenterIdAndRoleId();
  }, []);

  useEffect(() => {
    const fetchStudentData = async () => {
      if (loadingElements) return; // Wait until elements are loaded
      try {
        if (!studentIdFromUrl) return;

        const singleStudentData = await get(
          `Student/GetStudentByIdAsync?studentId=${studentIdFromUrl}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const registration = singleStudentData;

        if (!registration) return;

        setSelectedCenterId(registration?.centerId);
        setSelectedClassId(registration?.centerClassId);

        const countryId = registration?.countryId;
        const stateId = registration?.stateId;
        const cityId = registration?.cityId;
        const centerId = registration?.centerId;
        const centerClassId = registration?.centerClassId;
        const centerSessionId = registration?.centerSessionId;
        const classSectionId = registration?.classSectionId;
        const languageId = registration?.language;
        const careTakerId = registration?.careTakerId;

        let selectedCountry = null;
        let selectedState = null;
        let selectedCity = null;
        let selectedCenter = null;
        let selectedClass = null;
        let selectedSession = null;
        let selectedSection = null;
        let selectedLanguage = null;
        let selectedCaretaker = null;

        const countriesResponse = await get("Dropdown/GetCountries", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setCountries(countriesResponse);
        selectedCountry = countriesResponse.find(
          (country) => country.id === countryId
        );

        const classesResponse = await get(
          `CenterClass/GetClassCenterByCenterId?id=${centerId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setClassesData(classesResponse);
        selectedClass = classesResponse.find(
          (classItem) => classItem.id === centerClassId
        );

        const languagesResponse = await get(`Language/GetAllLanguageAsync`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setLanguagesData(languagesResponse);
        selectedLanguage = languagesResponse.find(
          (languageItem) => languageItem.id === languageId
        );

        const caretakersResponse = await get(
          `UserAuthentication/GetUsersByCenterIdAndRoleId?centerId=${centerId}&roleId=${4}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setNanniesData(caretakersResponse);
        selectedCaretaker = caretakersResponse.find(
          (caretaker) => caretaker.id === careTakerId
        );

        if (countryId) {
          const statesResponse = await get(
            `Dropdown/GetStates?countryId=${countryId}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          setStates(statesResponse);

          // if (stateId) {
          //   selectedState = statesResponse.find(
          //     (state) => state.id === stateId
          //   );
          //   const citiesResponse = await get(
          //     `Dropdown/GetCities?stateId=${stateId}`,
          //     {
          //       headers: {
          //         Authorization: `Bearer ${token}`,
          //       },
          //     }
          //   );
          //   setCities(citiesResponse);

          //   if (cityId) {
          //     selectedCity = citiesResponse.find((city) => city.id === cityId);
          //     const centersResponse = await get(
          //       `Center/GetCenterByCityId?cityId=${cityId}`,
          //       {
          //         headers: {
          //           Authorization: `Bearer ${token}`,
          //         },
          //       }
          //     );
          //     setCentersData(centersResponse?.center);

          if (centerId) {
            // selectedCenter = centersResponse?.center.find(
            //   (center) => center.id === centerId
            // );

            if (centerClassId) {
              const sessionsResponse = await get(
                `Session/GetSessionByCenterId?centerId=${centerId}`,
                {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                }
              );

              const sessions = sessionsResponse?.session || [];
              setSessionsData(sessions);

              if (centerSessionId) {
                selectedSession = sessionsResponse?.session.find(
                  (session) => session.id === centerSessionId
                );
                const sectionsResponse = await get(
                  `ClassSection/GetAllSectionByCenterClassIdAndCenterId?centerClassId=${centerClassId}&centerId=${centerId}`,
                  {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  }
                );
                setSectionsData(sectionsResponse);

                if (classSectionId) {
                  selectedSection = sectionsResponse.find(
                    (section) => section.id === classSectionId
                  );
                }
              }
            }
          }
          //   }
          // }
        }

        if (
          registration.studentImage !== "" &&
          registration.studentImage !== null
        ) {
          const imageUrl =
            process.env.REACT_APP_LIVE_DOMAIN_URL +
            "ExternalImages" +
            registration.imagePath;

          setPreviewUrl(imageUrl);
          setStudentFileName(registration.studentImage);
        }
        // Batch File Counts and URLs
        const newFileCounts = {};
        const newFileUrls = {};
        const mappedElements =
          registration?.elementDetailsDto?.length > 0
            ? registration.elementDetailsDto.map((element, index) => {
                const matchingElement = elementsData.find(
                  (item) => item.id === element.elementId
                );

                // Construct correct file URL
                const filePath = element.filePath.startsWith("/")
                  ? element.filePath
                  : `/${element.filePath}`;
                const fileUrl = `${process.env.REACT_APP_LIVE_DOMAIN_URL}ExternalImages${filePath}`;

                // Update file counts and URLs
                newFileCounts[index] = element.fileName ? 1 : 0;
                newFileUrls[index] = fileUrl;

                return {
                  id: element.id || 0,
                  value: element.value || "",
                  name: matchingElement
                    ? { value: matchingElement.id, label: matchingElement.name }
                    : null,
                  description: element.description || "",
                  elementDetail: {
                    ...element.elementDetail,
                    value: element.value || "",
                    description: element.description || "",
                    effectiveDate: element.effectiveDate?.split("T")[0] || null,
                    endDate: element.endDate?.split("T")[0] || null,
                    fileName: element.fileName || "",
                    filePath: element.filePath || "",
                    base64String: element.base64String || "",
                  },
                };
              })
            : [
                {
                  name: "",
                  description: "",
                  createdBy: localStorage.getItem("userId"),
                  elementDetail: {
                    value: "",
                    description: "",
                    effectiveDate: null,
                    endDate: null,
                    createdBy: localStorage.getItem("userId"),
                    fileName: "",
                    filePath: "",
                    base64String: "",
                  },
                },
              ];

        setFileCounts(newFileCounts);
        setFileUrls(newFileUrls);

        // console.log("here", mappedElements);

        reset({
          id: registration?.id,
          studentFirstRegistrationId: registration?.studentFirstRegistrationId,
          organizationId: localStorage.getItem("organizationId"),
          firstName: registration?.firstName,
          lastName: registration?.lastName,
          dateOfBirth: registration?.dateOfBirth.split("T")[0],
          gender: registration?.gender === 0 ? "0" : "1",
          nationality: registration?.nationality,
          religion: registration?.religion,
          countryId: { id: selectedCountry?.id, label: selectedCountry?.name },
          // stateId: { id: selectedState?.id, label: selectedState?.name },
          // cityId: { id: selectedCity?.id, label: selectedCity?.name },
          stateId: 0,
          cityId: 0,
          stateName: registration.stateName,
          cityName: registration.cityName,
          centerId: { id: selectedCenter?.id, label: selectedCenter?.name },
          centerClassId: { id: selectedClass?.id, label: selectedClass?.name },
          centerSessionId: {
            id: selectedSession?.id,
            label: selectedSession?.name,
          },
          classSectionId: {
            id: selectedSection?.id,
            label: selectedSection?.name,
          },
          careTakerId: {
            id: selectedCaretaker?.id,
            label: selectedCaretaker?.firstName,
          },
          registrationNo: registration?.registrationNo,
          guardianIdentityNo: registration?.guardianIdentityNo,
          createdBy: registration?.createdBy || localStorage.getItem("userId"),
          updatedBy: registration?.updatedBy || localStorage.getItem("userId"),
          studentImage: registration?.studentImage || "",
          imagePath: registration?.imagePath || "",
          base64String: "",
          code: registration?.code || "",
          rollNo: registration?.rollNo,
          grandParentsName: registration?.grandParentsName,
          guardianName: "",
          admissionDate: registration?.admissionDate.split("T")[0],
          placeOfBirth: registration?.placeOfBirth,
          language: { id: selectedLanguage?.id, label: selectedLanguage?.name },
          iBanNo: registration?.iBanNo,
          email: registration?.email,
          studentPassword: registration?.studentPassword,

          isITDeviceAllocated: registration?.isITDeviceAllocated,
          itRemarks: registration?.itRemarks,
          itDeviceAllocatedDate:
            registration?.itDeviceAllocatedDate?.split("T")[0],
          isUniformAllocated: registration?.isUniformAllocated,
          uniformRemarks: registration?.uniformRemarks,
          uniformAllocatedDate:
            registration?.uniformAllocatedDate?.split("T")[0],
          isStationeryAllocated: registration?.isStationeryAllocated,
          stationeryRemarks: registration?.stationeryRemarks,
          stationeryAllocatedDate:
            registration?.stationeryAllocatedDate?.split("T")[0],
          isCardPriniting: registration?.isCardPriniting,
          cardPrinitingRemarks: registration?.cardPrinitingRemarks,
          cardPrinitingAllocatedDate:
            registration?.cardPrinitingAllocatedDate?.split("T")[0],
          elements: mappedElements,
        });
      } catch (error) {
        console.error("Error fetching student data:", error);
      }
    };

    if (studentIdFromUrl) {
      fetchStudentData();
    }
  }, [studentIdFromUrl, loadingElements]);

  useEffect(() => {
    const getAllClassSectionsByClassIdAndCenterId = async () => {
      try {
        const response = await get(
          `ClassSection/GetAllSectionByCenterClassIdAndCenterId?centerClassId=${selectedClassId}&centerId=${selectedCenterId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setSectionsData(response);
      } catch (error) {
        console.error("Error fetching sections:", error);
      }
    };

    if (selectedCenterId && selectedClassId) {
      getAllClassSectionsByClassIdAndCenterId();
    }
  }, [selectedCenterId, selectedClassId]);

  useEffect(() => {
    const getSessionsList = async () => {
      if (!token) {
        console.error("Unauthorized.");
        return;
      }

      try {
        const response = await get(
          `Session/GetSessionByCenterId?centerId=${centerId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setSessionsData(response.session);
      } catch (error) {
        console.error("Error fetching sessions:", error);
      }
    };

    getSessionsList();
  }, [setValue, watch]);

  useEffect(() => {
    const getLanguagesList = async () => {
      if (!token) {
        console.error("Unauthorized.");
        return;
      }

      try {
        const response = await get(`Language/GetAllLanguageAsync`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setLanguagesData(response);
      } catch (error) {
        console.error("Error fetching sessions:", error);
      }
    };

    getLanguagesList();
  }, [setValue, watch]);

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      setStudentFileName(file.name);

      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result.split(",")[1];
        setValue("base64String", base64String, { shouldValidate: true });
        setPreviewUrl(reader.result);
        trigger("studentImage");
      };
      reader.readAsDataURL(file);
    } else {
      setPreviewUrl(null);
      setStudentFileName("");
    }
  };

  const genders = [
    {
      id: 1,
      name: "Male",
    },
    {
      id: 0,
      name: "Female",
    },
  ];

  const saveData = async (data) => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    const elements = data?.elements
      ?.map((element) => {
        if (!element.name || element.name.value === undefined) {
          return null;
        }

        return {
          id: element.name.value || 0,
          name: element.name?.label || element.name || "",
          description: element.description || "",
          createdBy: localStorage.getItem("userId"),
          elementDetail: {
            value: element.elementDetail?.value || "",
            description: element.elementDetail?.description || "",
            effectiveDate: element.elementDetail?.effectiveDate || null,
            endDate: element.elementDetail?.endDate || null,
            createdBy: localStorage.getItem("userId"),
            fileName: element.elementDetail?.fileName || "",
            filePath: element.elementDetail?.filePath || "",
            base64String: element.elementDetail?.base64String || "",
          },
        };
      })
      .filter((element) => element !== null);

    const formData = {
      ...data,
      studentImage: studentFileName,
      countryId: data?.countryId?.value || data?.countryId?.id,
      stateId: 0,
      cityId: 0,
      stateName: data.stateName,
      cityName: data.cityName,
      centerId: selectedCenterId,
      centerClassId: data?.centerClassId?.value || data?.centerClassId?.id,
      centerSessionId:
        data?.centerSessionId?.value || data?.centerSessionId?.id,
      classSectionId: data?.classSectionId?.value || data?.classSectionId?.id,
      gender: data?.gender,
      language: data?.language?.value || data?.language?.id || 0,
      careTakerId: data?.careTakerId?.value || data?.careTakerId?.id || 0,
      guardianName: "",
      custodianName: "",
      grandParentsName: "",
      religion: "",
      isDisabled: false,
      disabledDescription: "",
      isMedical: false,
      medicalDescription: "",
      isOnMedication: false,
      medicationDescription: "",
      isDivorced: false,
      elements: elements?.length > 0 ? elements : null,
      ...(data?.id
        ? {}
        : {
            FormId: 21,
            NotificationEventTypeIds: NotificationEventTypes.ADD.toString(),
          }),
    };

    // console.log("data", data);
    // console.log("formData", formData);
    // return;

    try {
      const response = await post("Student/AddUpdateStudentAsync", formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.isSuccess) {
        toast.success("Success!");
        // reset(getDefaultStudentFormValues());
        // setPreviewUrl(null);
        navigate("/students");
      }
    } catch (error) {
      console.error("Error.", error);
    }
  };

  const [missingDependencies, setMissingDependencies] = useState([]);

  const handleOkButtonClick = (dependency) => {
    setShowDependencyModal(false);

    if (dependency === "sessions") {
      navigate("/sessions");
    } else if (dependency === "sections") {
      navigate("/sections");
    } else if (dependency === "subjects") {
      navigate("/subjects");
    }
  };
  const handleChangeOfInputWithLengthCheck = (fieldName) => (e) => {
    const value = e.target.value;
    setValue(fieldName, value, { shouldValidate: true });
  };

  return (
    <>
      <div className="page-header d-flex mb-2">
        <h2 className="page-heading fs-7">Student Form</h2>
      </div>

      <div className="card">
        <div className="card-body">
          <form
            className="row g-3 new-form-style"
            onSubmit={handleSubmit(saveData)}
          >
            <div className="col-md-12">
              <div className="row g-3 justify-content-center">
                <div className="col-md-3">
                  <div className="image-uploader-wrapper d-flex flex-column align-items-center">
                    <label className="form-label mb-3">Student Photo</label>
                    <div className="image-preview d-flex justify-content-center align-items-center mb-2">
                      {previewUrl ? (
                        <img src={previewUrl} alt="No Preview" />
                      ) : (
                        <div>
                          <span className="fas fa-image fs-3 text-light"></span>
                        </div>
                      )}
                    </div>
                    <p className="text-center fs-10 mb-0">{studentFileName}</p>
                    <input
                      {...register("studentImage")}
                      type="file"
                      className="form-control"
                      accept="image/*"
                      onChange={handleFileChange}
                    />
                  </div>
                  {errors.studentImage && (
                    <small className="text-danger">
                      {errors.studentImage.message}
                    </small>
                  )}
                </div>
              </div>
            </div>

            <h5 className="mb-0 p-2 px-3 mt-4 text-secondary bg-brand-light rounded-pill">
              Admission Information
            </h5>

            <div className="col-12">
              <div className="row g-2">
                <div className="col d-none">
                  <label className="form-label form-label-new">
                    Voucher No.
                  </label>
                  <input
                    {...register(`voucherNo`)}
                    type="text"
                    className="form-control"
                    placeholder=""
                    onBlur={() => fetchFirstRegistrationData()}
                    disabled={true}
                  />
                  {errors.voucherNo && (
                    <small className="text-danger">
                      {errors.voucherNo.message}
                    </small>
                  )}
                </div>
                <div className="col">
                  <label className="form-label form-label-new">
                    Roll No. (Student Code)
                  </label>
                  <input
                    {...register(`code`)}
                    type="text"
                    className="form-control"
                    placeholder=""
                    disabled={true}
                  />
                  {errors.code && (
                    <small className="text-danger">{errors.code.message}</small>
                  )}
                </div>
                <div className="col">
                  <label className="form-label form-label-new">
                    Country<span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name={`countryId`}
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={countries.map((country) => ({
                          value: country.id,
                          label: country.name,
                        }))}
                        onChange={(selectedOption, actionMeta) => {
                          if (actionMeta.action === "clear") {
                            setValue(`countryId`, null);
                          } else {
                            setValue(
                              `countryId`,
                              selectedOption || { value: 0, label: "" }
                            );
                          }
                          trigger(`countryId`);
                        }}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        isDisabled={true}
                      />
                    )}
                  />
                  {errors.countryId && (
                    <small className="text-danger">
                      {errors.countryId.message}
                    </small>
                  )}
                </div>
                <div className="col">
                  <label className="form-label form-label-new">
                    State<span className="text-danger fs-9">*</span>
                  </label>
                  <input
                    {...register("stateName", {
                      required: "This field is required.",
                    })}
                    type="text"
                    className="form-control"
                    disabled
                  />
                  {errors.currentContact?.stateName && (
                    <small className="text-danger">
                      {errors.currentContact.stateName.message}
                    </small>
                  )}
                </div>
                <div className="col">
                  <label className="form-label form-label-new">
                    City<span className="text-danger fs-9">*</span>
                  </label>
                  <input
                    {...register("cityName", {
                      required: "This field is required.",
                    })}
                    type="text"
                    className="form-control"
                    disabled
                  />
                  {errors.currentContact?.cityName && (
                    <small className="text-danger">
                      {errors.currentContact.cityName.message}
                    </small>
                  )}
                </div>
                {/* <div className="col">
                  <label className="form-label form-label-new">
                    State<span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name={`stateId`}
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={states.map((state) => ({
                          value: state.id,
                          label: state.name,
                        }))}
                        onChange={(selectedOption, actionMeta) => {
                          if (actionMeta.action === "clear") {
                            setValue(`stateId`, null);
                          } else {
                            setValue(
                              `stateId`,
                              selectedOption || { value: 0, label: "" }
                            );
                          }
                          trigger(`stateId`);
                        }}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        isDisabled={true}
                      />
                    )}
                  />
                  {errors.stateId && (
                    <small className="text-danger">
                      {errors.stateId.message}
                    </small>
                  )}
                </div>
                <div className="col">
                  <label className="form-label form-label-new">
                    City<span className="text-danger fs-9">*</span>
                  </label>

                  <Controller
                    name={`cityId`}
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={cities.map((city) => ({
                          value: city.id,
                          label: city.name,
                        }))}
                        onChange={(selectedOption, actionMeta) => {
                          if (actionMeta.action === "clear") {
                            setValue(`cityId`, null);
                          } else {
                            setValue(
                              `cityId`,
                              selectedOption || { value: 0, label: "" }
                            );
                          }
                          trigger(`cityId`);
                        }}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        isDisabled={true}
                      />
                    )}
                  />
                  {errors.cityId && (
                    <small className="text-danger">
                      {errors.cityId.message}
                    </small>
                  )}
                </div> */}
                {/* <div className="col">
                  <label className="form-label form-label-new">
                    Center<span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name={`centerId`}
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={centersData.map((center) => ({
                          value: center.id,
                          label: center.name,
                        }))}
                        onChange={(selectedOption, actionMeta) => {
                          if (actionMeta.action === "create-option") {
                            setValue(`centerId`, {
                              value: 0,
                              label: selectedOption.label,
                            });
                          } else if (actionMeta.action === "clear") {
                            setValue(`centerId`, null);
                          } else {
                            setValue(
                              `centerId`,
                              selectedOption || { value: 0, label: "" }
                            );
                          }
                          trigger(`centerId`);
                        }}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        isDisabled={true}
                      />
                    )}
                  />
                  {errors.centerId && (
                    <small className="text-danger">
                      {errors.centerId.message}
                    </small>
                  )}
                </div> */}
              </div>
            </div>

            <div className="col-12">
              <div className="row g-2">
                <div className="col">
                  <label className="form-label form-label-new">
                    Session<span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name={`centerSessionId`}
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={sessionsData.map((session) => ({
                          value: session.id,
                          label: session.name,
                        }))}
                        onChange={(selectedOption, actionMeta) => {
                          if (actionMeta.action === "create-option") {
                            setValue(`centerSessionId`, {
                              value: 0,
                              label: selectedOption.label,
                            });
                          } else if (actionMeta.action === "clear") {
                            setValue(`centerSessionId`, null);
                          } else {
                            setValue(
                              `centerSessionId`,
                              selectedOption || { value: 0, label: "" }
                            );
                          }
                          trigger(`centerSessionId`);
                        }}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        isDisabled={true}
                      />
                    )}
                  />
                  {errors.centerSessionId && (
                    <small className="text-danger">
                      {errors.centerSessionId.message}
                    </small>
                  )}
                </div>
                <div className="col">
                  <label className="form-label form-label-new">
                    Class<span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name={`centerClassId`}
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={classesData.map((classItem) => ({
                          value: classItem.id,
                          label: classItem.name,
                        }))}
                        onChange={(selectedOption, actionMeta) => {
                          if (actionMeta.action === "create-option") {
                            setValue(`centerClassId`, {
                              value: 0,
                              label: selectedOption.label,
                            });
                          } else if (actionMeta.action === "clear") {
                            setValue(`centerClassId`, null);
                          } else {
                            setValue(
                              `centerClassId`,
                              selectedOption || { value: 0, label: "" }
                            );
                          }
                          trigger(`centerClassId`);
                        }}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        isDisabled={true}
                      />
                    )}
                  />
                  {errors.centerClassId && (
                    <small className="text-danger">
                      {errors.centerClassId.message}
                    </small>
                  )}
                </div>
                <div className="col">
                  <label className="form-label form-label-new">
                    Section<span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name={`classSectionId`}
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={sectionsData.map((sectionItem) => ({
                          value: sectionItem.id,
                          label: sectionItem.name,
                        }))}
                        onChange={(selectedOption, actionMeta) => {
                          if (actionMeta.action === "create-option") {
                            setValue(`classSectionId`, {
                              value: 0,
                              label: selectedOption.label,
                            });
                          } else if (actionMeta.action === "clear") {
                            setValue(`classSectionId`, null);
                          } else {
                            setValue(
                              `classSectionId`,
                              selectedOption || { value: 0, label: "" }
                            );
                          }
                          trigger(`classSectionId`);
                        }}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        isClearable
                      />
                    )}
                  />
                  {errors.classSectionId && (
                    <small className="text-danger">
                      {errors.classSectionId.message}
                    </small>
                  )}
                </div>
                <div className="col">
                  <label className="form-label form-label-new">
                    Entry Date<span className="text-danger fs-9">*</span>
                  </label>
                  <input
                    {...register(`admissionDate`, {
                      required: "This field is required.",
                    })}
                    type="date"
                    className="form-control"
                    placeholder=""
                    // disabled={true}
                  />
                  {errors.admissionDate && (
                    <small className="text-danger">
                      {errors.admissionDate.message}
                    </small>
                  )}
                </div>
              </div>
            </div>

            <h5 className="mb-0 p-2 px-3 mt-4 text-secondary bg-brand-light rounded-pill">
              Student Information
            </h5>

            <div className="col-12">
              <div className="row gx-2 gy-3 row-cols-4">
                <div className="col">
                  <label className="form-label form-label-new">
                    First Name<span className="text-danger fs-9">*</span>
                  </label>
                  <input
                    {...register("firstName", {
                      required: "This field is required.",
                      maxLength: {
                        value: 75,
                        message: "Maximum of 75 characters allowed.",
                      },
                    })}
                    type="text"
                    className="form-control"
                    placeholder=""
                    onChange={handleChangeOfInputWithLengthCheck("firstName")}
                    disabled={true}
                  />
                  {errors.firstName && (
                    <small className="text-danger">
                      {errors.firstName.message}
                    </small>
                  )}
                </div>
                <div className="col">
                  <label className="form-label form-label-new">
                    Last Name<span className="text-danger fs-9">*</span>
                  </label>
                  <input
                    {...register("lastName", {
                      required: "This field is required.",
                      maxLength: {
                        value: 75,
                        message: "Maximum of 75 characters allowed.",
                      },
                    })}
                    type="text"
                    className="form-control"
                    placeholder=""
                    onChange={handleChangeOfInputWithLengthCheck("lastName")}
                    disabled={true}
                  />
                  {errors.lastName && (
                    <small className="text-danger">
                      {errors.lastName.message}
                    </small>
                  )}
                </div>
                <div className="col">
                  <label className="form-label form-label-new">
                    Gender<span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name="gender"
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <select
                        {...field}
                        className="form-select"
                        value={field.value || ""}
                        onChange={(e) => field.onChange(Number(e.target.value))}
                      >
                        <option value="" disabled key={"gender-key"}>
                          Select
                        </option>
                        {genders.map((gender) => (
                          <option key={gender.id} value={gender.id}>
                            {gender.name}
                          </option>
                        ))}
                      </select>
                    )}
                    disabled={true}
                  />
                  {errors.gender && (
                    <small className="text-danger">
                      {errors.gender.message}
                    </small>
                  )}
                </div>
                <div className="col">
                  <label className="form-label form-label-new">
                    GreGorian DOB<span className="text-danger fs-9">*</span>
                  </label>
                  <input
                    type="date"
                    {...register(`dateOfBirth`, {
                      required: "This field is required.",
                      validate: {
                        notFutureDate: (value) =>
                          (value && new Date(value) <= new Date()) ||
                          "Future dates are not allowed.",
                        notBefore2000: (value) =>
                          (value &&
                            new Date(value) >= new Date("2000-01-01")) ||
                          "Dates before the year 2000 are not allowed.",
                      },
                    })}
                    className="form-control"
                    min="2000-01-01"
                    max={new Date().toISOString().split("T")[0]}
                    disabled={true}
                  />
                  {errors.dateOfBirth && (
                    <small className="text-danger">
                      {errors.dateOfBirth.message}
                    </small>
                  )}
                </div>
                <div className="col">
                  <label className="form-label form-label-new">
                    Nationality<span className="text-danger fs-9">*</span>
                  </label>
                  <input
                    {...register(`nationality`, {
                      required: "This field is required.",
                      maxLength: {
                        value: 75,
                        message: "Maximum of 75 characters allowed.",
                      },
                    })}
                    type="text"
                    className="form-control"
                    placeholder=""
                    onChange={handleChangeOfInputWithLengthCheck("nationality")}
                    disabled={true}
                  />
                  {errors.nationality && (
                    <small className="text-danger">
                      {errors.nationality.message}
                    </small>
                  )}
                </div>
                <div className="col">
                  <label className="form-label form-label-new">
                    Id Number
                    <span className="text-danger fs-9">*</span>
                  </label>
                  <input
                    {...register(`guardianIdentityNo`, {
                      required: "This field is required.",
                    })}
                    type="text"
                    className="form-control"
                    placeholder=""
                    disabled={true}
                  />
                  {errors.guardianIdentityNo && (
                    <small className="text-danger">
                      {errors.guardianIdentityNo.message}
                    </small>
                  )}
                </div>
                <div className="col">
                  <label className="form-label form-label-new">Email</label>
                  <input
                    {...register(`email`)}
                    type="text"
                    className="form-control"
                    placeholder=""
                    disabled={true}
                  />
                  {errors.email && (
                    <small className="text-danger">
                      {errors.email.message}
                    </small>
                  )}
                </div>
                <div className="col">
                  <label className="form-label form-label-new">Password</label>
                  <input
                    {...register(`studentPassword`)}
                    type="text"
                    className="form-control"
                    placeholder=""
                    disabled={true}
                  />
                </div>
              </div>
            </div>

            <h5 className="mb-0 p-2 px-3 mt-4 text-secondary bg-brand-light rounded-pill">
              Care Taker Information
            </h5>

            <div className="col-12">
              <div className="row g-2">
                <div className="col-3">
                  <label className="form-label form-label-new">
                    Select Nanny
                  </label>
                  <Controller
                    name={`careTakerId`}
                    control={control}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={nanniesData.map((nanny) => ({
                          value: nanny.id,
                          label: nanny.firstName + " " + nanny.lastName,
                        }))}
                        onChange={(selectedOption, actionMeta) => {
                          if (actionMeta.action === "clear") {
                            setValue(`careTakerId`, 0);
                          } else {
                            setValue(
                              `careTakerId`,
                              selectedOption || { value: 0, label: "" }
                            );
                          }
                          trigger(`careTakerId`);
                        }}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        isClearable
                      />
                    )}
                  />
                  {errors.careTakerId && (
                    <small className="text-danger">
                      {errors.careTakerId.message}
                    </small>
                  )}
                </div>
              </div>
            </div>

            <h5 className="mb-0 p-2 px-3 mt-4 text-secondary bg-brand-light rounded-pill">
              Banking Information
            </h5>

            <div className="col-12">
              <div className="row g-2">
                <div className="col-3">
                  <label className="form-label form-label-new">IBAN</label>
                  <input
                    {...register("iBanNo")}
                    type="text"
                    className="form-control"
                    placeholder=""
                    disabled={true}
                  />
                  {errors.iBanNo && (
                    <small className="text-danger">
                      {errors.iBanNo.message}
                    </small>
                  )}
                </div>
              </div>
            </div>
            <Elements
              fields={elementsFormFields}
              control={control}
              register={register}
              errors={errors}
              watch={watch}
              elementsData={elementsData}
              append={appendElementsFormFields}
              remove={removeElementsFormFields}
              handleAttachmentFileChange={handleAttachmentFileChange}
              fileCounts={fileCounts}
              fileUrls={fileUrls}
              setValue={setValue}
              getValues={getValues}
              trigger={trigger}
            />
            <div className="col-12">
              <button
                className="btn btn-primary btn-sm"
                type="submit"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Save" : "Save"}
              </button>
            </div>
          </form>
        </div>
      </div>

      {showDependencyModal &&
        missingDependencies.length > 0 &&
        missingDependencies.map((dependency) => (
          <CheckDependencyModal
            key={dependency}
            title={
              dependency === "sessions"
                ? "No Sessions Found"
                : dependency === "sections"
                ? "No Sections Found"
                : ""
            }
            message={
              dependency === "sessions"
                ? "Please create at least one session before proceeding to the student form."
                : dependency === "sections"
                ? "Please create at least one section of the selected class before proceeding to the student form."
                : ""
            }
            onClose={() => setShowDependencyModal(false)}
            okButtonLabel={
              dependency === "sessions"
                ? "Go to Sessions"
                : dependency === "sections"
                ? "Go to Sections"
                : ""
            }
            okButtonClick={() => handleOkButtonClick(dependency)}
          />
        ))}
    </>
  );
}

export default StudentForm;
